import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = [ 'container', 'clinic' ]
  static values = { pin: String }

  connect() {
    this.element[this.identifier] = this

    import(`../images/${this.pinValue}`).then(pinImage => {
      this.pinImage = pinImage.default;
    });
  }

  init() {
    const _this = this
    ymaps.ready(() => {
      _this.containerTarget.querySelectorAll('ymaps').forEach(e => e.remove())

      const size = _this.containerTarget.getBoundingClientRect()

      const points = []
      const placemarks = []
      _this.clinicTargets.forEach(element => {
        placemarks.push(new ymaps.Placemark(
          [element.dataset.lat, element.dataset.lng],
          {
            closeButton: false,
            balloonContentBody: element.querySelector('.invisible').innerHTML
          },
          {
            iconLayout: 'default#image',
            iconImageHref: _this.pinImage,
            iconImageOffset: [-15, -65],
          }
        ))
        points.push([element.dataset.lat, element.dataset.lng])
      });
      const params = ymaps.util.bounds.getCenterAndZoom(ymaps.util.bounds.fromPoints(points), [size.width, size.height], null, { margin: [70, 30, 10, 30] })
      params['controls'] = ['zoomControl', 'geolocationControl', 'fullscreenControl']
      if (points.length == 1) params.zoom = 17 ;

      const map = new ymaps.Map(_this.containerTarget, params, { suppressMapOpenBlock: true });
      map.behaviors.disable('scrollZoom');
      placemarks.forEach(placemark => map.geoObjects.add(placemark))
      _this.containerTarget.querySelector('ymaps').querySelectorAll('*').forEach( el => el.classList.add('bvi-no-styles') );
    })
  }
}
